import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
// import Dashboard from '../views/Dashboard.vue'
// import Categories from '../views/Categories.vue'
// import Statement from '../views/Statement.vue'
// import Accounts from '../views/Accounts.vue'
// import Reports from '../views/Reports.vue'
// import Settings from '../views/Settings.vue'
// import Notifications from '../views/Notifications.vue'

// import BudgetDashboard from '../views/Budget/Dashboard.vue'
import BudgetDetails from '../views/Budget/Details.vue'
import BudgetCreate from '../views/Budget/Create.vue'
import BudgetMonth from '../views/Budget/Month.vue'

import Subscription from '../views/Subscription/Subscription.vue'
import NewSubscription from '../views/Subscription/NewSubscription.vue'
import Help from '../views/Help.vue'
import MoreMenu from '../views/MoreMenu.vue'
// import Reminders from '../views/Reminders.vue'

import Login from '../new/views/pages/Auth/Login.vue'
import Restore from '../new/views/pages/Auth/Restore.vue'
import Register from '../new/views/pages/Auth/Register.vue'

import PageNotFound from '../new/views/pages/PageNotFound.vue'
import InDevelopment from '../new/views/pages/InDevelopment.vue'

// NEW

import Dashboard from '../new/views/pages/Dashboard.vue'
import Categories from '../new/views/pages/Categories.vue'
import Reminders from '../new/views/pages/Reminders.vue'
import Statement from '../new/views/pages/Statement.vue'
import BudgetDashboard from '../new/views/pages/Budget/Dashboard.vue'
import Accounts from '../new/views/pages/Accounts.vue'
import Settings from '../new/views/pages/Settings.vue'
import SettingsNotifications from '../new/views/pages/Settings/Notifications.vue'
import Reports from '../new/views/pages/Reports.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Главная',
        component: Dashboard,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/categories',
        name: 'Категории',
        component: Categories,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/budget',
        name: 'Бюджет',
        component: BudgetDashboard,
        meta: {
            requiresAuth: true,
            inDevelopmentFlag: 'budget_available',
        }
    },
    {
        path: '/budget/create',
        name: 'Создание бюджета',
        component: BudgetCreate,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/budget/:id',
        name: 'Бюджет',
        component: BudgetDetails,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/budget/:id/month/:date',
        name: 'Бюджет',
        component: BudgetMonth,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/statement',
        name: 'Операции',
        component: Statement,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/accounts',
        name: 'Счета',
        component: Accounts,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/reports',
        name: 'Отчеты',
        component: Reports,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/settings',
        name: 'Настройки',
        component: Settings,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/settings/notifications',
        name: 'Оповещения',
        component: SettingsNotifications,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/subscription',
        name: 'Подписка',
        component: Subscription,
        meta: {
            requiresAuth: true,
            inDevelopmentFlag: 'subscriptions_available'
        }
    },
    {
        path: '/subscription/:id',
        name: 'Оформление подписки',
        component: NewSubscription,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/help',
        name: 'Помощь',
        component: Help,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/menu',
        name: 'Меню',
        component: MoreMenu,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/reminders',
        name: 'Напоминания',
        component: Reminders,
        meta: {
            requiresAuth: true
        }
    },


    {
        path: '/login',
        name: 'Авторизация',
        component: Login,
        meta: {
            requiresGuest: true,
        }
    },
    {
        path: '/restore',
        name: 'Восстановление пароля',
        component: Restore,
        meta: {
            requiresGuest: true,
        }
    },
    {
        path: '/register',
        name: 'Регистрация',
        component: Register,
        meta: {
            requiresGuest: true,
        }
    },

    {
        path: '/notifications',
        name: 'Оповещения',
        component: InDevelopment,
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/dev',
        name: 'В разработке',
        component: InDevelopment
    },

    { path: "*", name: '404', component: PageNotFound }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.inDevelopmentFlag)) {
        if(!store.getters.features[to.meta.inDevelopmentFlag]) {
            next('/dev');
            return;
        }
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next();
            return;
        }
        next('/login');
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
        if (! store.getters.isLoggedIn) {
            next();
            return;
        }
        next('/');
    } else {
        next();
    }
})

export default router;